// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__OB9yi","logo-link":"Logo_logo-link__h++22","logo-wrp":"Logo_logo-wrp__gXY8R","logo-titles":"Logo_logo-titles__paHcg"};